import { render, staticRenderFns } from "./treeTransfer.vue?vue&type=template&id=f35acec0&"
import script from "./treeTransfer.vue?vue&type=script&lang=js&"
export * from "./treeTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports